import React from 'react';

import DocsGetStartedCard from './DocsGetStartedCard';
import DocsDownloadCard from './DocsDownloadCard';
import DocsVideoInstructionsCard from './DocsVideoInstructionsCard';

function Docs({ t }) {
  return (
    <div className="docs">
      <DocsGetStartedCard t={t} />
      <DocsDownloadCard t={t} />
      <DocsVideoInstructionsCard t={t} />
    </div>
  );
}

export default Docs;
